import { mapActions } from 'vuex'

export default {
  props: {
    loan: {
      required: true,
    },
  },

  data() {
    return {
      uuid: null,
      loanData: null,
    }
  },

  async created() {
    if (typeof this.loan === 'string') {
      this.uuid = this.loan
      this.loanData = await this.getLoansDetail(this.uuid)
    } else {
      this.uuid = this.loan.uuid
      this.loanData = this.loan
    }
  },

  methods: {
    ...mapActions('loan', ['getLoansDetail']),
  },
}
